"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColor = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const CommonDataProvider_1 = require("../../containers/CommonDataProvider");
const utils_1 = require("./utils");
const SportColors_types_1 = require("./SportColors.types");
const getColor = (sport, theme) => {
    const sportIconColorsView = (0, utils_1.getSportIconColorsView)(theme || betweb_openapi_axios_1.LayoutTheme.Light);
    if (!sport) {
        return sportIconColorsView[SportColors_types_1.ESportIconColorView.BROWN];
    }
    switch (sport) {
        case CommonDataProvider_1.ESportsCodes.FISHING:
        case CommonDataProvider_1.ESportsCodes.HANDBALL:
        case CommonDataProvider_1.ESportsCodes.LACROSSE:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.GREEN_1];
        case CommonDataProvider_1.ESportsCodes.FOOTBALL:
        case CommonDataProvider_1.ESportsCodes.CYBER_FOOTBALL:
        case CommonDataProvider_1.ESportsCodes.FIELD_HOCKEY:
        case CommonDataProvider_1.ESportsCodes.GAELIC_FOOTBALL:
        case CommonDataProvider_1.ESportsCodes.MINI_FOOTBALL:
        case CommonDataProvider_1.ESportsCodes.FUTSAL:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.GREEN_2];
        case CommonDataProvider_1.ESportsCodes.ARCHERY:
        case CommonDataProvider_1.ESportsCodes.BOX:
        case CommonDataProvider_1.ESportsCodes.BULLET_SHOOTING:
        case CommonDataProvider_1.ESportsCodes.DTM:
        case CommonDataProvider_1.ESportsCodes.NASCAR:
        case CommonDataProvider_1.ESportsCodes.DARTS:
        case CommonDataProvider_1.ESportsCodes.FORMULA_1:
        case CommonDataProvider_1.ESportsCodes.MIXED_MARTIAL_ARTS:
        case CommonDataProvider_1.ESportsCodes.MMA:
        case CommonDataProvider_1.ESportsCodes.MOTORCYCLE_RACING:
        case CommonDataProvider_1.ESportsCodes.PISTOL_SHOOTING:
        case CommonDataProvider_1.ESportsCodes.SPEEDWAY:
        case CommonDataProvider_1.ESportsCodes.TABLE_TENNIS:
        case CommonDataProvider_1.ESportsCodes.TRIATHLON:
        case CommonDataProvider_1.ESportsCodes.FREESTYLE_WRESTLING:
        case CommonDataProvider_1.ESportsCodes.GRECOROMAN_WRESTLING:
        case CommonDataProvider_1.ESportsCodes.RALLY:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.RED];
        case CommonDataProvider_1.ESportsCodes.KARATE:
        case CommonDataProvider_1.ESportsCodes.SLAP:
        case CommonDataProvider_1.ESportsCodes.FIST_FIGHTING:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.RED_2];
        case CommonDataProvider_1.ESportsCodes.DUATHLON:
        case CommonDataProvider_1.ESportsCodes.NORDIC_COMBINED:
        case CommonDataProvider_1.ESportsCodes.DIVING:
        case CommonDataProvider_1.ESportsCodes.FIGURE_SKATING:
        case CommonDataProvider_1.ESportsCodes.FREESTYLE:
        case CommonDataProvider_1.ESportsCodes.KABBADI:
        case CommonDataProvider_1.ESportsCodes.SHORT_TRACK:
        case CommonDataProvider_1.ESportsCodes.SKATEBOARDING:
        case CommonDataProvider_1.ESportsCodes.SKATING:
        case CommonDataProvider_1.ESportsCodes.SKELETON:
        case CommonDataProvider_1.ESportsCodes.ALPINE_SKIING:
        case CommonDataProvider_1.ESportsCodes.SKIING:
        case CommonDataProvider_1.ESportsCodes.SKI_JUMPING:
        case CommonDataProvider_1.ESportsCodes.SLED:
        case CommonDataProvider_1.ESportsCodes.SNOWBOARDING:
        case CommonDataProvider_1.ESportsCodes.SWIMMING:
        case CommonDataProvider_1.ESportsCodes.SYNCHRONIZED_SWIMMING:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.BLUE_1];
        case CommonDataProvider_1.ESportsCodes.CYBER_HOCKEY:
        case CommonDataProvider_1.ESportsCodes.ICE_HOCKEY:
        case CommonDataProvider_1.ESportsCodes.HOCKEY_WITH_BALL:
        case CommonDataProvider_1.ESportsCodes.SHORT_HOCKEY:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.BLUE_2];
        case CommonDataProvider_1.ESportsCodes.BIATHLON:
        case CommonDataProvider_1.ESportsCodes.BOBSLED:
        case CommonDataProvider_1.ESportsCodes.CURLING:
        case CommonDataProvider_1.ESportsCodes.CYBER_TENNIS:
        case CommonDataProvider_1.ESportsCodes.ROWING_ON_KAYAKS_AND_CANOES:
        case CommonDataProvider_1.ESportsCodes.TENNIS:
        case CommonDataProvider_1.ESportsCodes.WATER_POLO:
        case CommonDataProvider_1.ESportsCodes.SAILING:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.BLUE_3];
        case CommonDataProvider_1.ESportsCodes.BALLS:
        case CommonDataProvider_1.ESportsCodes.BILLIARDS:
        case CommonDataProvider_1.ESportsCodes.BOWLING:
        case CommonDataProvider_1.ESportsCodes.ROWING_ACADEMIC:
        case CommonDataProvider_1.ESportsCodes.TEQBOL:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.BLACK];
        case CommonDataProvider_1.ESportsCodes.AMERICAN_FOOTBALL:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.BLACK_2];
        case CommonDataProvider_1.ESportsCodes.BADMINTON:
        case CommonDataProvider_1.ESportsCodes.ATHLETICS:
        case CommonDataProvider_1.ESportsCodes.SEPAK_TAKRAW:
        case CommonDataProvider_1.ESportsCodes.VOLLEYBALL:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.YELLOW];
        case CommonDataProvider_1.ESportsCodes.SOFTBALL:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.YELLOW_1];
        case CommonDataProvider_1.ESportsCodes.GYMNASTICS:
        case CommonDataProvider_1.ESportsCodes.BASEBALL:
        case CommonDataProvider_1.ESportsCodes.BASKETBALL:
        case CommonDataProvider_1.ESportsCodes.BASKETBALL_3X3:
        case CommonDataProvider_1.ESportsCodes.CHESS:
        case CommonDataProvider_1.ESportsCodes.CYBER_BASKETBALL:
        case CommonDataProvider_1.ESportsCodes.NETBALL:
        case CommonDataProvider_1.ESportsCodes.PESAPALLO:
        case CommonDataProvider_1.ESportsCodes.WEIGHTLIFTING:
        case CommonDataProvider_1.ESportsCodes.AUSTRALIAN_FOOTBALL:
        case CommonDataProvider_1.ESportsCodes.PELOTA:
        case CommonDataProvider_1.ESportsCodes.PICKLEBALL:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.ORANGE];
        case CommonDataProvider_1.ESportsCodes.HURLING:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.ORANGE_1];
        case CommonDataProvider_1.ESportsCodes.CYBER_SPORT:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.PURPLE];
        case CommonDataProvider_1.ESportsCodes.CYCLING:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.GREEN_3];
        case CommonDataProvider_1.ESportsCodes.GOLF:
        case CommonDataProvider_1.ESportsCodes.CRICKET:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.GREEN_4];
        case CommonDataProvider_1.ESportsCodes.BRAWL_STARS:
        case CommonDataProvider_1.ESportsCodes.CLASH_ROYALE:
        case CommonDataProvider_1.ESportsCodes.CS2:
        case CommonDataProvider_1.ESportsCodes.FREE_FIRE:
        case CommonDataProvider_1.ESportsCodes.HEARTHSTONE:
        case CommonDataProvider_1.ESportsCodes.HEROES_OF_NEWERTH:
        case CommonDataProvider_1.ESportsCodes.MORTAL_KOMBAT_XL:
        case CommonDataProvider_1.ESportsCodes.PUBG:
        case CommonDataProvider_1.ESportsCodes.PUBG_MOBILE:
        case CommonDataProvider_1.ESportsCodes.WORLD_OF_WARCRAFT:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.YELLOW_2];
        case CommonDataProvider_1.ESportsCodes.CS_GO:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.YELLOW_3];
        case CommonDataProvider_1.ESportsCodes.APEX_LEGENDS:
        case CommonDataProvider_1.ESportsCodes.DOTA_2:
        case CommonDataProvider_1.ESportsCodes.GEARS_OF_WAR:
        case CommonDataProvider_1.ESportsCodes.STREET_FIGHTER_V:
        case CommonDataProvider_1.ESportsCodes.STREET_FIGHTER:
        case CommonDataProvider_1.ESportsCodes.TEKKEN_7:
        case CommonDataProvider_1.ESportsCodes.VAINGLORY:
        case CommonDataProvider_1.ESportsCodes.VALORANT:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.RED_1];
        case CommonDataProvider_1.ESportsCodes.HEROES_OF_THE_STORM:
        case CommonDataProvider_1.ESportsCodes.LEAGUE_OF_LEGENDS_WILD_RIFT:
        case CommonDataProvider_1.ESportsCodes.LEAGUE_OF_LEGENDS:
        case CommonDataProvider_1.ESportsCodes.ROCKET_LEAGUE:
        case CommonDataProvider_1.ESportsCodes.WARCRAFT_III:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.BLUE_4];
        case CommonDataProvider_1.ESportsCodes.AGE_OF_EMPIRES:
        case CommonDataProvider_1.ESportsCodes.KING_OF_GLORY:
        case CommonDataProvider_1.ESportsCodes.MOBILE_LEGENDS:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.YELLOW_4];
        case CommonDataProvider_1.ESportsCodes.ARENA_OF_VALOR:
        case CommonDataProvider_1.ESportsCodes.ARTIFACT:
        case CommonDataProvider_1.ESportsCodes.CROSSFIRE:
        case CommonDataProvider_1.ESportsCodes.HALO:
        case CommonDataProvider_1.ESportsCodes.QUAKE:
        case CommonDataProvider_1.ESportsCodes.RAINBOW_SIX:
        case CommonDataProvider_1.ESportsCodes.CALL_OF_DUTY:
        case CommonDataProvider_1.ESportsCodes.STARCRAFT:
        case CommonDataProvider_1.ESportsCodes.WORLD_OF_TANKS:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.GRAY];
        case CommonDataProvider_1.ESportsCodes.OVERWATCH:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.GRAY_1];
        case CommonDataProvider_1.ESportsCodes.STARCRAFT_2:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.BLUE_5];
        case CommonDataProvider_1.ESportsCodes.OVERWATCH_2:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.BROWN_1];
        case CommonDataProvider_1.ESportsCodes.FORTNITE:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.PURPLE_2];
        case CommonDataProvider_1.ESportsCodes.GWENT:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.GREEN];
        case CommonDataProvider_1.ESportsCodes.BEACH_SOCCER:
        case CommonDataProvider_1.ESportsCodes.BEACH_HANDBALL:
        case CommonDataProvider_1.ESportsCodes.BEACH_VOLLEYBALL:
        case CommonDataProvider_1.ESportsCodes.FLOORBALL:
        case CommonDataProvider_1.ESportsCodes.HORSEBACK_RIDING:
        case CommonDataProvider_1.ESportsCodes.HORSE_RACING:
        case CommonDataProvider_1.ESportsCodes.MODERN_PENTATHLON:
        case CommonDataProvider_1.ESportsCodes.RUGBY:
        case CommonDataProvider_1.ESportsCodes.RUGBY_7:
        case CommonDataProvider_1.ESportsCodes.RUGBY_UNION:
        case CommonDataProvider_1.ESportsCodes.RUGBY_LEAGUE:
        case CommonDataProvider_1.ESportsCodes.SQUASH:
        case CommonDataProvider_1.ESportsCodes.SUMO:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.RED_3];
        default:
            return sportIconColorsView[SportColors_types_1.ESportIconColorView.BROWN];
    }
};
exports.getColor = getColor;
//# sourceMappingURL=SportColors.js.map